import { render, staticRenderFns } from "./SubscriptionStatusPage.vue?vue&type=template&id=4c05fb64&scoped=true&"
import script from "./SubscriptionStatusPage.vue?vue&type=script&lang=js&"
export * from "./SubscriptionStatusPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c05fb64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c05fb64')) {
      api.createRecord('4c05fb64', component.options)
    } else {
      api.reload('4c05fb64', component.options)
    }
    module.hot.accept("./SubscriptionStatusPage.vue?vue&type=template&id=4c05fb64&scoped=true&", function () {
      api.rerender('4c05fb64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Account/Children/Subscription/SubscriptionStatusPage.vue"
export default component.exports